/**
 * @generated SignedSource<<ff8a7caee1ac3705c09df09fceac78d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RailCreator_creator$data = {
  readonly browseLink: string | null;
  readonly displayName: string | null;
  readonly urlLabel: string | null;
  readonly " $fragmentType": "RailCreator_creator";
};
export type RailCreator_creator$key = {
  readonly " $data"?: RailCreator_creator$data;
  readonly " $fragmentSpreads": FragmentRefs<"RailCreator_creator">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RailCreator_creator",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "browseLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlLabel",
      "storageKey": null
    }
  ],
  "type": "PhotoCreator",
  "abstractKey": null
};

(node as any).hash = "ac772ab803ca1c4872ab317f5ff2e78a";

export default node;
